import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    if (! map.syntax.isAvailable) {
        return null
    }

    const onClick = () => map.commands.checkCircularReference()

    return {
        key: 'check-circular-reference',
        label: '循环引用检测',
        onClick,
    }
}
